function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
import utils from './utils';
var Clock = function () {
    function Clock(player) {
        _classCallCheck(this, Clock);
        this.player = player;
        this.clockItem = player.template.videoClockItem;
        this.video = player.video;
        this.wait = 0;
        this.waitTip = player.template.waitTip;
        this.timer = null;
        this.init();
    }
    _createClass(Clock, [
        {
            key: 'init',
            value: function init() {
                var _this = this;
                this.clockItem.forEach(function (el, index) {
                    el.addEventListener(utils.nameMap.dragEnd, function () {
                        _this.set(el.dataset.time * 60, function () {
                            _this.player.pause();
                            _this.reset();
                        });
                        _this.clockItem.forEach(function (e) {
                            e.classList.remove('focus');
                        });
                        el.classList.add('focus');
                    });
                });
            }
        },
        {
            key: 'set',
            value: function set(time) {
                var _this2 = this;
                var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
                };
                this.clear();
                if (typeof time !== 'number' || time <= 0) {
                    this.waitTip.innerHTML = '';
                    this.hide(false);
                    this.player.set.show('playerSet');
                    this.player.template.videoClock.classList.remove('active');
                    return;
                }
                this.wait = +time;
                this.waitTip.innerHTML = utils.secondToTime(this.wait);
                this.player.template.videoClock.classList.add('active');
                this.timer = setInterval(function () {
                    if (_this2.wait < 0) {
                        _this2.waitTip.innerHTML = '';
                        cb();
                        _this2.clear();
                        return;
                    }
                    _this2.waitTip.innerHTML = utils.secondToTime(_this2.wait - 1);
                    _this2.wait--;
                }, 1000);
                this.hide(false);
                this.player.set.show('playerSet');
            }
        },
        {
            key: 'clear',
            value: function clear() {
                clearInterval(this.timer);
                this.timer = null;
            }
        },
        {
            key: 'reset',
            value: function reset() {
                this.clockItem.forEach(function (e) {
                    e.classList.remove('focus');
                });
                this.clockItem[0].classList.add('focus');
            }
        },
        {
            key: 'show',
            value: function show() {
                this.player.set.show('videoClock');
            }
        },
        {
            key: 'hide',
            value: function hide() {
                var clearAll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                this.player.set.hide('videoClock', clearAll);
            }
        }
    ]);
    return Clock;
}();
export {
    Clock as default
};